

@if (type) {
  <div class="event-si-filter-item">

    <div class="flex align-items-center column-gap-2">
      <p-checkbox inputId="_{{type}}" [binary]="true" [ngModel]="selected" (onChange)="onCheckboxChange($event, type)"></p-checkbox>


      <div class="flex flex-column">
        <div class="flex flex-row gap-1">
          <span class="font-bold">
            {{ ('EventShopItemFilterItemType.' + type) | translate }}
          </span>
        </div>
        <div class="details-block-wrap text-xs line-height-1">
          <!-- <div class="detail-block">

          </div> -->
          <!-- </div class="detail-block">

          </div> -->
        </div>
      </div>

    </div>

    <ng-content select="[slot=drag]">

    </ng-content>

  </div>
}